import * as Yup from 'yup';

import firstPartyDataSchema from './ProfileFields/FirstPartyDataSchema';

const schema = () =>
  Yup.object().shape({
    company: Yup.object().shape({
      label: Yup.string(),
      value: Yup.string().required('Please enter an organization'),
    }),
    firstName: Yup.string().required('Please enter a first name'),
    lastName: Yup.string().required('Please enter a last name'),
    jobTitle: Yup.object().shape({
      label: Yup.string(),
      value: Yup.mixed(),
    }),
    ...firstPartyDataSchema({ isRequired: true }),
  });

export default schema;
